import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

import moment from "moment";

const initialState = {
    notifications: [],
    toasts: [],
    failures: []
};

const setNotifications = (state, action) => {
    let replies = [...action.data];
    let nuwenotifications = [];
    let nuwetoasts = [];
    for (const notification of replies) {
        if (notification.viewed || !notification.push) {
            nuwenotifications.push(notification);
        } else {
            nuwenotifications.push(notification);
            nuwetoasts.push(notification);
        }
    }
    return updateObject(state, { notifications: nuwenotifications, toasts: nuwetoasts });
};

const getNotificationsFailed = (state, action) => {
    return updateObject(state, { failures: [...state.failures, { error: { error: action.error, easymessage: action.easymessage, status: action.status, message: action.message }, loading: false }] });
};

const addNotification = (state, action) => {
    let nuwenotifications = [...state.notifications];
    let nuwetoasts = [...state.toasts];
    let index = state.notifications.map(item => item.id).indexOf(action.data.id);
    if (index === -1) {
        nuwenotifications.push(action.data);
        if (action.data.push && !action.data.viewed) {
            nuwetoasts.push(action.data);
        }
    }
    return updateObject(state, { notifications: nuwenotifications, toasts: nuwetoasts });
};

const removeNotification = (state, action) => {
    let list = [...state.toasts];
    const index = list.findIndex(e => e.id === action.id);
    list.splice(index, 1);
    let notificationslist = [...state.notifications];
    const notificationsindex = notificationslist.findIndex(e => e.id === action.id);
    notificationslist[notificationsindex].viewed = moment.utc();
    return updateObject(state, { toasts: list, notifications: notificationslist });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return initialState;
        case actionTypes.SET_NOTIFICATIONS:
            return setNotifications(state, action);
        case actionTypes.GET_NOTIFICATIONS_FAILED:
            return getNotificationsFailed(state, action);
        case actionTypes.ADD_NOTIFICATION:
            return addNotification(state, action);
        case actionTypes.REMOVE_NOTIFICATION:
            return removeNotification(state, action);
        default:
            return state;
    }
};

export default reducer;